import { gql } from '@apollo/client'

export const ACKNOWLEDGE_HEARTBEAT_ERRORS = gql`
  mutation AcknowledgeHeartbeatErrors(
    $errorIds: [String!]
    $locationName: String
  ) {
    acknowledgeHeartbeatErrors(
      errorIds: $errorIds
      locationName: $locationName
    ) {
      success
      acknowledgedCount
    }
  }
`
